import { useDispatch } from "react-redux";
import { loginWithRedirect } from "../actions/user";

const useLogin = () => {
    const dispatch = useDispatch();

    return {
        loginWithRedirect: (path: string) => dispatch(loginWithRedirect(path)),
    };
};

export default useLogin;
